import React from 'react'

import AIListItem from './AIListItem'

import styles from './AIList.module.css'

const AIList = ({ layerId, ai }) => {
  return (
    <div className={styles.layerItems}>
      {ai.map(({ id }) => (
        <AIListItem id={id} layerId={layerId} key={id} />
      ))}
    </div>
  )
}
export default AIList
